const ListTable = require('app/ui/list/Table');
const Modal = require('app/ui/Modal');

const PaymentForm = require('app/billing/payment/Form');

class PendingTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'invoice': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildFooter = this.buildFooter.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.invoice = this.settings.invoice;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
    }

    buildTab(){

        this.$tableContainer = $('<div/>')
        .addClass('white-box');

        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-9 p-2')
                .append(this.$tableContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-3 p-2')
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(
                        $('<h3/>')
                        .addClass("box-title")
                        .append(window.translate('filters'))
                    )
                    .append( this.buildFilterForm())
                )
            )
        )



        this.initializeListTable();

        this.onDOMReady();
    }

    buildFilterForm(){
        this.$filterForm = $('<form/>')
        .addClass('billing-payment-pending-search-form');

        this.$filterByType = $('<select/>')
        .attr('id','type')
        .attr('name','type')
        .addClass('form-control')
        .append(
            $('<option/>')
            .val('')
            .append('-')
        );

        let availablesTypes = [1,2,3];
        for(var i in availablesTypes){
            let value = availablesTypes[i];
            let label = window.translate('billing.invoice.type.'+value);

            this.$filterByType
            .append(
                $('<option/>')
                .val(value)
                .append(label)
            );
        }


        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"type")
                .append(window.translate('app.billing.invoice.search.byType.label'))
            )
            .append(this.$filterByType)
        )

        this.$filterByType.on('change',this.onSubmitFilterForm);
        this.$filterForm.on('submit',this.onSubmitFilterForm);

        return this.$filterForm;
    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'reference',
            'date',
            'customerName',
            'ttc',
            'customer { name email }',
            'totalAlreadyPayed',
            'remainingDue',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped billing-invoice-list',
            'footerBuilder': {
                'mode': 'custom',
                'render': this.buildFooter,
            },
            'showPagination': false,
            'id': 'list-billing-invoices',
            'length': 0,//leave 0 to show all and retrieve all 
            'graphQL': {
                'queryType': 'billingInvoices',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'index',
                    'label': '#',
                    'class': 'billing-invoice-index',
                    'render': function(item,index){
                        return parseInt(index) + 1;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('billing.invoice.date.label'),
                    'class': 'billing-invoice-date',
                    'render': function(item,index){
                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('billing.payment.invoice.label'),
                    'class': 'billing-invoice-reference',
                    'render': function(item,index){
                        return item.node.reference;
                    },
                },
                {
                    'name': 'customer',
                    'label': window.translate('billing.invoice.customer.label'),
                    'class': 'billing-invoice-customer',
                    'render': function(item,index){
                        return item.node.customer ? item.node.customer.name : item.node.customerName;
                    },
                },
                {
                    'name': 'totalAlreadyPayed',
                    'label': window.translate('payed'),
                    'class': 'billing-invoice-totalAlreadyPayed',
                    'render': function(item,index){
                        return window.formatFloat(item.node.totalAlreadyPayed) + ' &euro;';
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'billing-invoice-total',
                    'render': function(item,index){
                        return window.formatFloat(item.node.ttc) + ' &euro;';
                    },
                },
                {
                    'name': 'remainingDue',
                    'label': window.translate('remainingDue'),
                    'class': 'billing-invoice-remainingDue',
                    'render': function(item,index){
                        return window.formatFloat(item.node.remainingDue) + ' &euro;';
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'billing-payment-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

                        let $btnCreate = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-primary')
                        .attr('title',window.translate('app.billing.payment.list.tabs.pending.actions.create.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-plus')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickCreate(item.node,$btn);
                        });
                        btns.push($btnCreate);

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildFooter(data){
        let $row = $('<tr/>');

        if(data.length <= 1){
            return '';
        }

        let totalAlreadyPayed = 0;
        let total = 0;
        let totalRemainingDue = 0;

        for(var i in data){
            let item = data[i].node;
            total += parseFloat(item.ttc);
            totalAlreadyPayed += parseFloat(item.totalAlreadyPayed);
            totalRemainingDue += parseFloat(item.remainingDue);
        }

        $row
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append(window.translate('total'))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalAlreadyPayed) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(total) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalRemainingDue) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )

        return $row;
    }

    buildGraphQLParameters(){
        let filters = {
            'customerType': 'Restaurant',
            'fullyPayed': false,
        };

        if(this.$filterByType && this.$filterByType.val()){
            filters.type = parseInt(this.$filterByType.val());
        }

        let orderBy = 'date';
        let dir = "ASC";

        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    onClickCreate(item,$btn){
        var self = this;
        let form = new PaymentForm({
            'payment': null,
            'invoice': item,
            'success': function(){
                self.paymentModal.dispose();
                self.refresh();
            }
        });

        this.paymentModal = new Modal({
            'title': window.translate('app.billing.payment.form.create.title'),
            'modalSize': 'xxl',
            'content': form.getForm()
        });

        this.paymentModal.show();
    }
}

module.exports = PendingTab;

